var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.29134 11.833V6.06009L6.44967 7.90176L5.45801 6.87467L8.99967 3.33301L12.5413 6.87467L11.5497 7.90176L9.70801 6.06009V11.833H8.29134ZM4.74967 14.6663C4.36009 14.6663 4.02658 14.5276 3.74915 14.2502C3.47172 13.9728 3.33301 13.6393 3.33301 13.2497V11.1247H4.74967V13.2497H13.2497V11.1247H14.6663V13.2497C14.6663 13.6393 14.5276 13.9728 14.2502 14.2502C13.9728 14.5276 13.6393 14.6663 13.2497 14.6663H4.74967Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.417ca0d4576f1f6341a239f3a99d89b2.svg";
export { ForwardRef as ReactComponent };